/**
 * @type {"Authorization"}
 */
const AUTH_COOKIE_NAME = 'Authorization'

module.exports = {
  AUTH_COOKIE_NAME,
}
